import notifications from "../notifications/notificationService";

const getMessage = (resp) => {
  if (resp.response) {
    resp = resp.response; // unwrap from axios error
  }
  return resp && resp.data && resp.data.message ? resp.data.message :
    resp && resp.data && typeof(resp.data) === 'string' ? resp.data :
    resp && typeof(resp) === 'string' ? resp : null;
};

const trimQuotes = (str) => {
  return str ? str.replace(/(^")|("$)/g, "") : null;
};

const useResponseHandler = () => {

  const handleError = (error) => {
    const message = getMessage(error) || 'The operation was not successful';
    notifications.push({ description: trimQuotes(message), type: 'error' });
  };

  return { handleError };
};

export default useResponseHandler;